import { gql } from '@apollo/client';

const GET_EVENT_CHANGE_DATE_REVIEW = gql`
  query GetEventChangeDateReview($id: Int!) {
    eventDateChangeReview(id: $id) {
      Id
      EventId
      SubmitComment
      StartDate
      EndDate
      Status
      DeclineComment
      FDAReviewerName
      ActionType
      AppraisalProgramYear
      MddapOrgUnit {
        Name
        MddapOrganization {
          Name
        }
      }
    }
  }
`;

export default GET_EVENT_CHANGE_DATE_REVIEW;
